// @ts-expect-error virtual file
import { addRouteMiddleware, defineNuxtPlugin, useColorMode } from '#imports'
import { useUserSession } from '../composables/userSession'

export default defineNuxtPlugin(() => {
  const colorMode = useColorMode()
  const { user } = useUserSession()

  addRouteMiddleware('_themeMiddleware', async (to) => {
    if (colorMode) {
      colorMode.preference = 'system'
    }
    const preferredTheme = user.value?.theme || 'system'
    if (preferredTheme !== 'system') {
      to.meta.colorMode = preferredTheme
    }
  }, {
    global: true,
  })
})
